export const getViewport = (
	filePath = "",
	viewportKey = "m"
) => (
	filePath.includes('/resources/images') || decodeURIComponent(filePath).includes("@") || decodeURIComponent(filePath).includes(".gif")
		? filePath
		: filePath.replace(/(\%2F)(?!.*\%2F)/g, "%2F" + viewportKey + "@")
);
